import React from 'react';
const Erro404 = () => {
    var host = window.location.href;
    if(host.indexOf("index.html") > -1){
      window.location.href = 'https://app.foco90.com.br';
    }
    return (
        <div className="jumbotron">
            <h1 className="display-3">Ocorreu um erro ao carregar a página, tente novamente.</h1>
        </div>
    );
}
export default Erro404;



// WEBPACK FOOTER //
// ./src/classes/errors/Erro404.js